export const HOST = "https://eduskills.uz"
